import { inject, Injectable } from '@angular/core';
import { PrincipalService } from '@ms/core';
import { SharedConstants } from '../shared/shared.constants';

@Injectable({
    providedIn: 'root',
})
export class DepartmentShareService {
    departments: string[] = [];
    principalService = inject(PrincipalService);
    isAdmin = false;
    constructor() {
        this.principalService.state$.subscribe(state => {
            if (state.authenticated) {
                this.departments = state.user.teacher?.departments.map(d => d.id) ?? [];
                this.isAdmin = this.principalService.hasAnyAuthorityDirect([
                    SharedConstants.ROLE_TENANT_ADMIN,
                    SharedConstants.ROLE_ADMIN,
                ]);
            } else {
                this.departments = [];
                this.isAdmin = false;
            }
        });
    }
}
